import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import useAuth from "./hooks/useAuth";

export default function App() {
    const { checkAuth } = useAuth();

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    return (
        <>
            <RouterProvider router={router} />
        </>
    );
}
